module.exports = __webpack_public_path__ + "img/xy_cn_w.3bb0696.png";